module.exports = __webpack_public_path__ + "static/led-screen-c-0a6ada2c68a480c3c9a9e35781e2a1ac.jpg";